import { render, staticRenderFns } from "./ResetPwd.vue?vue&type=template&id=146dd88f&scoped=true&"
import script from "./ResetPwd.vue?vue&type=script&lang=js&"
export * from "./ResetPwd.vue?vue&type=script&lang=js&"
import style0 from "@/less/login.less?vue&type=style&index=0&id=146dd88f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146dd88f",
  null
  
)

export default component.exports